import { format, isSameDay, isSameMonth, startOfMonth, endOfMonth, isBefore, isAfter } from 'date-fns';

export const isDayDisabled = (day: Date, disabledDays: Date[], minDate: Date, maxDate: Date): boolean => {
    return disabledDays.some(date => isSameDay(date, day)) || day < minDate || day > maxDate;
};

export const isInSelectedRange = (
    day: Date,
    rangeStart: Date | null,
    rangeEnd: Date | null,
    hoverDate: Date | null
): boolean => {
    if (!rangeStart) return false;

    if (rangeEnd) {
        return day >= rangeStart && day <= rangeEnd;
    }

    // When hovering in range selection mode
    if (hoverDate && rangeStart && !rangeEnd) {
        return (day >= rangeStart && day <= hoverDate) || (day >= hoverDate && day <= rangeStart);
    }

    return false;
};

export const createEventsByDateMap = (events: Event[]) => {
    const map = new Map();
    if (events && events.length > 0) {
        events.forEach(event => {
            if (event && event.date) {
                const dateKey = format(event.date, 'yyyy-MM-dd');
                map.set(dateKey, event);
            }
        });
    }
    return map;
};

export const findEvent = (day: Date, eventsByDate: Map<string, Event>) => {
    const dateKey = format(day, 'yyyy-MM-dd');
    return eventsByDate.get(dateKey);
};

export const isNavigationDisabled = (
    currentMonth: Date,
    minDate: Date,
    maxDate: Date
) => {
    return {
        isPrevDisabled: isBefore(startOfMonth(currentMonth), startOfMonth(minDate)),
        isNextDisabled: isAfter(endOfMonth(currentMonth), endOfMonth(maxDate))
    };
};
